.dropdown-menu-item {
  position: relative;
  overflow: inherit;

  &:hover > .dropdown-menu-items {
    display: block;
  }
}

.dropdown-title {
  display: flex;
}

.dropdown-title-name {
  flex-grow: 2;
}

.dropdown-top-level-svg {
  display: inline-block;
  position: relative;
  top: 13%;
  height: 13px;
  width: 13px;

  &.disabled {
    cursor: default;
    opacity: 0.4;
  }
}

.dropdown-menu-items {
  border-radius: 4px;
  max-height: 325px;
  overflow-y: auto;
  max-width: 385px;
  box-shadow: 1px 1px 3px var(--dark--box-shadow-color--2);
  margin-right: 1px;

  display: none;

  right: 100%;
  position: absolute;
  top: 0;
}

.lock-icon {
  width: 12px;
  height: 12px;
}

.lock-icon-wrapper {
  transform: scale(1);
}
